export const contactTypes = [
  { value: 'Comercial', label: 'Comercial' },
  { value: 'Dúvidas Empresas', label: 'Dúvidas Empresas' },
  { value: 'Dúvidas Investidor', label: 'Dúvidas Investidor' },
  { value: 'Marketing', label: 'Marketing' },
  { value: 'Outras Dúvidas', label: 'Outras Dúvidas' },
  { value: 'Problemas de Cadastro/Login', label: 'Problemas de Cadastro/Login' },
  { value: 'Sugestões', label: 'Sugestões' }
]
